import { Injectable } from '@angular/core';
import {Http,Response,Headers,RequestOptions} from "@angular/http";
import {server,comment_store,comment_show,comment_delete,comment_list_by_post} from "./index.path";
import {Credentials} from "../models/credentials";
import {LocalDataService} from "../services/local-data.service";
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import 'rxjs/add/observable/of';
import { Observable } from 'rxjs/Observable';
import { CredentialsService } from '../nservices/login/credentials.service';
@Injectable()
export class CommentService {

  url_store = server+comment_store;
  url_show_one = server+comment_show;
  url_delete_one = server+comment_delete;
  url_list_by_post = server+comment_list_by_post;

  loader:boolean = false;

  credentials?:Credentials;
  constructor(public http: Http,private _credentialsS:CredentialsService) {
    // console.log('Hello CommentProvider Provider');

  }

  storeComment(post_id:number,comment:string){
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization':'Bearer '+this._credentialsS.getCredentialsToken()});
    let options = new RequestOptions({ headers: headers });
    let body={
      "post_id": post_id,
      "comment": comment,
    }
    return this.http.post(this.url_store,body,options)
          .map((res: any) => {
              return res.json();
          }).catch((err: Response) => {
            let error = err.json();
            alert("Ups! ocurrio un problema al realizar el comentario "+error.message);
            return Observable.throw(error)
          });
  }

  getByPost(post_id: number){
    // console.log('CommentService getByPost');
    //this.presentLoading("Estamos cargando los comentarios");
    let url_final = this.url_list_by_post + post_id + "/comments";
    return this.http.get(url_final)
    .map((res: any) => {
        return res.json();
    }).catch((err: Response) => {
      let error = err.json();
      // console.log("fallo servicio getByPost: "+error.message);
      alert(error.message);
      return Observable.throw(error)
    })
  }

  deleteComment(id_comment:number){
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization':'Bearer '+this._credentialsS.getCredentialsToken()});
    let options = new RequestOptions({ headers: headers });
    let url_final = this.url_delete_one+String(id_comment);
    console.log("delete url: "+url_final);
    
    return this.http.delete(url_final,options)
          .map((res: any) => {
            return res.json();
          }).catch((err: Response) => {
            let error = err.json();
            // console.log("fallo servicio storeComment: "+error.message);
            if(String(error.error).includes("You can only delete your own comments"))
              alert("Solo puedes eliminar commentarios que sean tuyos o de publicaciones que tu realizaste");
            return Observable.throw(error)
          })
  }

}



// WEBPACK FOOTER //
// C:/Users/CLAUDIA/Desktop/Timeplacebook2/src/app/services/comment.service.ts